(() => {
  function destroyTestimonials(section) {
    if (!section || !section.swiper) return;
    section.swiper.destroy(true, true);
    delete section.swiper;
    delete section.dataset.swiperReady;
  }

  function initTestimonials(section) {
    if (!section || section.dataset.swiperReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const container = section.querySelector('.sunster-rvac-testimonials__viewport');
    const nextEl = section.querySelector('.sunster-rvac-testimonials__nav--next');
    const prevEl = section.querySelector('.sunster-rvac-testimonials__nav--prev');
    const slideCount = container?.querySelectorAll('.swiper-slide').length || 0;
    if (!container || !nextEl || !prevEl || !slideCount) return;

    const swiper = new Swiper(container, {
      initialSlide: 0,
      loop: false,
      slidesPerView: 'auto',
      slidesOffsetBefore: 62,
      slidesOffsetAfter: 62,
      spaceBetween: 24,
      speed: 600,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        0: {
          slidesOffsetBefore: 39,
          slidesOffsetAfter: 39,
          spaceBetween: 12,
        },
        750: {
          slidesOffsetBefore: 62,
          slidesOffsetAfter: 62,
          spaceBetween: 24,
        },
      },
    });

    section.dataset.swiperReady = 'true';
    section.swiper = swiper;
  }

  function syncTestimonials(root = document) {
    root.querySelectorAll('[data-sunster-rvac-testimonials]').forEach(initTestimonials);
  }

  document.addEventListener('DOMContentLoaded', () => syncTestimonials());
  document.addEventListener('shopify:section:load', (event) => syncTestimonials(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sunster-rvac-testimonials]').forEach(destroyTestimonials);
  });
})();
